import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { Plus, Minus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/5 last:border-0" data-id="element-66">
      <button className="w-full py-8 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-67">
        <span className={`text-lg md:text-xl font-bold transition-colors duration-300 pr-8 font-sans leading-snug ${isOpen ? 'text-pink-400' : 'text-white'}`} data-id="element-68">
          {question}
        </span>
        <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 shrink-0 ${isOpen ? 'bg-pink-500 text-navy-950 rotate-180' : 'bg-white/5 text-pink-400'}`} data-id="element-69">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-70" /> : <Plus className="w-4 h-4" data-id="element-71" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] pb-8 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-72">
        <p className="text-gray-200 leading-relaxed text-base md:text-lg font-sans opacity-95 border-l-2 border-pink-500/30 pl-6 py-2" data-id="element-73">
          {answer}
        </p>
      </div>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Funciona para mi especialidad? Hago cejas / lashes / faciales / uñas con diseño.',
    a: 'El sistema funciona para cualquier profesional de belleza que trabaje por turnos y venda por WhatsApp o Instagram. Los scripts, protocolos y herramientas están adaptados para el rubro en general, con variantes específicas para los servicios más comunes: manicura, extensiones de pestañas, diseño de cejas, estética facial y nail art.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Acceso inmediato por email al completar el pago. En menos de 5 minutos recibís todos los Tomos y Bonos en formato PDF, listos para abrir en el celular o la computadora. No necesitás crear ninguna cuenta ni instalar nada.'
  }, {
    q: '¿Qué lo diferencia de los consejos gratuitos de Instagram sobre cómo cobrar señas?',
    a: 'Los consejos de Instagram te dicen qué hacer. Este sistema te dice cómo hacerlo, con el mensaje exacto para cada situación, el protocolo paso a paso y las herramientas listas para copiar y aplicar hoy. No hay interpretación ni improvisación de tu parte. Abrís el Tomo, encontrás la situación, copiás el mensaje y lo mandás.'
  }, {
    q: '¿Funciona si tengo pocas clientas o acabo de empezar?',
    a: 'Sí. El sistema funciona desde la primera consulta que llegue. De hecho, implementarlo desde el principio es mucho más fácil que hacerlo después de años de hábitos instalados. Empezar con el sistema correcto desde el día 1 te evita meses de improvisación.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Garantía de 7 días completos. Si abrís el material y no cumple lo que prometemos, escribís a mundopractico.oficial@gmail.com y te devolvemos el 100% del pago. Sin formularios, sin preguntas, sin demora.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-74">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-75">
        <FadeIn data-id="element-76">
          <div className="flex flex-col items-center mb-16" data-id="element-77">
            <div className="bg-white/5 text-gray-400 px-6 py-2 rounded-full border border-white/10 text-xs font-bold tracking-[0.2em] mb-6 uppercase" data-id="element-78">
              DESPEJÁ TUS DUDAS
            </div>
            <h2 className="text-3xl md:text-5xl text-center text-white leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-79">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h2>
          </div>
          <div className="bg-navy-950 rounded-3xl border border-white/10 p-8 md:p-12" data-id="element-80">
            {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} data-id="element-81" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};